import React from "react";
import RequestCoursesTable from "../../../components/RequestCoursesTable/RequestCoursesTable";
import UnpublishedCoursesTable from "../../../components/UnpublishedCoursesTable/UnpublishedCoursesTable";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useDispatch } from "react-redux";
import { getPendingApprovalCoursesAPI, getUnpublishedCoursesRequestsAPI } from "../../../redux/features/intructorSlice";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

const RequestCourses = () => {
  const dispatch = useDispatch();

  const fetchPendingApprovalCourses = async (token) => {
    return await dispatch(getPendingApprovalCoursesAPI({ token })).unwrap();
  };

  const fetchUnpublishedCoursesRequests = async (token) => {
  return await dispatch(getUnpublishedCoursesRequestsAPI({ token })).unwrap();
};

  return (
    <>
      {/* Top Bar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Course Approval Requests</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <InstructorNotification />
          </div>
        </div>
      </div>
      <div className="card-default-style px-14 py-40">
        <RequestCoursesTable fetchApi={fetchPendingApprovalCourses} isCourseTable={true} />
      </div>
          <hr className="mt-40"/>
      <h3 className="ad-heading-04 fw-bold my-40 ">Course Unpublished Requests</h3>

      <div className="card-default-style px-14 py-40">
        <UnpublishedCoursesTable fetchApi={fetchUnpublishedCoursesRequests} isCourseTable={true} />
      </div>
    </>
  );
};

export default RequestCourses;
